import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack, Typography } from "@mui/material";
import { trimTrailingZeroes } from "../uttils/common";
import { TeamA } from "../values/constants";

const StyledTableCell = styled(TableCell)(({ theme, id }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: id == "Bowlers" ? "red" : theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },

  // [`&.${tableCellClasses.body}`]: {
  //   fontSize: 14,
  //   border: "none",
  //   backgroundColor: id === "specificId" ? "lightblue" : "white", // Conditional color
  // },
}));

// const StyledTableCell = styled(TableCell)(({ theme, id }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: id === "specificId" ? "blue" : "#F4F4F4", // Conditional color
//     color: theme.palette.common.black,
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 14,
//     border: "none",
//     backgroundColor: id === "specificId" ? "lightblue" : "white", // Conditional color
//   },
// }));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  //   "&:nth-of-type(odd)": {
  //     backgroundColor: theme.palette.action.hover,
  //   },
  //   // hide last border
  //   "&:last-child td, &:last-child th": {
  //     border: 0,
  //   },
}));

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];

export default function ScoreCardTable(props) {
  const {
    live,
    scoreBoard,
    currentActiveTab,
    wicketTypes,
    teamName,
    totalOvers,
    totalRunsScored,
    totalWickets,
  } = props;
  const teamAData = scoreBoard?.teamA;
  const teamBData = scoreBoard?.teamB;
  const currentActiveScoreCardData =
    currentActiveTab == TeamA ? scoreBoard?.teamA : scoreBoard?.teamB;
  const currentInActiveScoreCardData =
    currentActiveTab == TeamA ? scoreBoard?.teamB : scoreBoard?.teamA;

  console.log("currentActiveScoreCardData", currentActiveScoreCardData);

  if (
    live?.teamBatting?.teamId !== currentActiveScoreCardData?.teamId &&
    currentActiveScoreCardData?.teamScoreboard?.battingCurrentBall <= 0
  ) {
    return <Stack>Yet to bat</Stack>;
  }
  return (
    <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell colSpan={6}>
              <Stack direction={"row"} display={"flex"}>
                <Stack flex={1}>
                  <Typography variant="h5">{teamName}</Typography>
                </Stack>
                <Stack>
                  <Typography variant="h5">
                    {totalRunsScored}-{totalWickets} ({totalOvers} Ov)
                  </Typography>
                </Stack>
              </Stack>
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow key={"BATTING"} sx={{ backgroundColor: "#F4F4F4" }}>
            <StyledTableCell component="th" scope="row">
              BATTING
            </StyledTableCell>
            <StyledTableCell align="right">R</StyledTableCell>
            <StyledTableCell align="right">B</StyledTableCell>
            <StyledTableCell align="right">4s</StyledTableCell>
            <StyledTableCell align="right">6s</StyledTableCell>
            <StyledTableCell align="right">SR</StyledTableCell>
          </StyledTableRow>

          {currentActiveScoreCardData?.sortBatsmen()?.activeBatsmen?.map(
            (item) => (
              <StyledTableRow key={item.playerName}>
                <StyledTableCell component="th" scope="row">
                  <Stack direction={"row"}>
                    <Stack display={"flex"} flex={1}>
                      {item.playerName}
                    </Stack>
                    <Stack display={"flex"} flex={1}>
                      <Typography ml={1} variant="subtitle2">
                        {item?.getWicketStr(
                          wicketTypes,
                          currentInActiveScoreCardData?.playerScores
                        )}
                      </Typography>
                    </Stack>
                  </Stack>
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.battingRuns || 0}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.ballsPlayed || 0}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.noOf4s || 0}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.noOf6s || 0}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {trimTrailingZeroes(item?.getSr().toFixed(2))}
                </StyledTableCell>
              </StyledTableRow>
            )

            //   <ScoringDataCard
            //     playerName={item?.playerName}
            //     wicketStr={item?.getWicketStr(
            //       wicketTypes,
            //       teamBData?.playerScores,
            //     )}
            //     title2={item?.battingRuns || 0}
            //     title3={item?.ballsPlayed || 0}
            //     title4={item?.noOf4s || 0}
            //     title5={item?.noOf6s || 0}
            //     title6={trimTrailingZeroes(item?.getSr().toFixed(2))}
            //     isStriker={item?.isStriker && !item?.wicketTypeId}
            //     isCaptain={item?.is_captain}
            //     isWicketKeeper={item?.is_wicketkeeper}
            //   />
          )}
        </TableBody>

        <TableBody>
          <StyledTableRow key={"dsfsdfdsfsd"}>
            <StyledTableCell colSpan={6} component="th" scope="row">
              <Stack direction={"row"} spacing={1}>
                <Typography variant="subtitle2" sx={{ color: "#000" }}>
                  Did not bat:
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#000", fontWeight: 400, ml: 3 }}
                >
                  {(currentActiveScoreCardData
                    ?.sortBatsmen()
                    ?.inactiveBatsmen.map(
                      (item) =>
                        `${item.playerName}${item?.is_captain ? " (c)" : ""}${
                          item?.is_wicketkeeper ? " (wk)" : ""
                        }`
                    )
                    .join(", ")).length <= 0
                    ? "NA"
                    : currentActiveScoreCardData
                        ?.sortBatsmen()
                        ?.inactiveBatsmen.map(
                          (item) =>
                            `${item.playerName}${
                              item?.is_captain ? " (c)" : ""
                            }${item?.is_wicketkeeper ? " (wk)" : ""}`
                        )
                        .join(", ")}
                </Typography>
              </Stack>
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow key={"dsfsdfdsfsd"}>
            <StyledTableCell colSpan={6} component="th" scope="row">
              <Stack direction={"row"} spacing={1}>
                <Typography variant="subtitle2" sx={{ color: "#000" }}>
                  Fall of wickets:
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#000", fontWeight: 400, ml: 3 }}
                >
                  NA
                </Typography>
              </Stack>
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow key={"Bowlers"} sx={{ backgroundColor: "#F4F4F4" }}>
            <StyledTableCell component="th" scope="row">
              Bowlers
            </StyledTableCell>
            <StyledTableCell align="right">O</StyledTableCell>
            <StyledTableCell align="right">M</StyledTableCell>
            <StyledTableCell align="right">R</StyledTableCell>
            <StyledTableCell align="right">W</StyledTableCell>
            <StyledTableCell align="right">ECON</StyledTableCell>
          </StyledTableRow>
          {currentInActiveScoreCardData
            ?.sortBowlers()
            ?.activeBowlers.map((item) => (
              <StyledTableRow key={item?.playerName}>
                <StyledTableCell component="th" scope="row">
                  {item?.playerName}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {trimTrailingZeroes(item?.getActualOvers()) || 0}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.getTotalBowlingRuns() || 0}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.noOfWickets || 0}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.maidenOvers || 0}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {trimTrailingZeroes(item?.getEconomyRate())}
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
